module.exports = __webpack_public_path__ + "static/media/desktop-viewer.f8d299a8.gif";